import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/customer-dashboard/payments/page.tsx");
